import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  width: 25vw;
`

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #13b478;
  padding: 10px;
`

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #004b50;
`

export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const DataRowWrapper = styled.div<any>`
  margin-top: 10px;
`

export const DataRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e1e3e6;
  margin-top: 10px;
  opacity: 0.5;
`

export const DataLabel = styled.span`
  font-size: 14px;
`
